import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class messageService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/messages');
  }

  addReplyEmail(body: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/messages/reply`, body);
  }

  connectGmail(userId: any, company_id: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}/email-connect/auth-url?userId=${userId}&company_id=${company_id}`);
  }

  deleteGmail(id:any,body:any){
    return this.http.post(`${environment.apiUrl}/email-connect/stop-watch/${id}`, body);
  }

  groupMessage(body: any, isEmailSync?: boolean): Observable<any> {
    let url = `${environment.apiUrl}/messages/group-message`;
  
    // Add query parameter if isEmailSync is defined
    if (isEmailSync !== undefined) {
      url += `?isEmailSync=${isEmailSync}`;
    }
  
    return this.http.post(url, body);
  }
}
